export const environmentMockServer = {
  production: false,
  BASE_URL: 'http://test.squeezer-software.com:9991/Squeezer-Technologies/Ar-project-demo/'
};

